import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { VorlagenQuerySorterConfig } from 'fa-kt.types';
import { VorlagenService } from '../service';

@Component({
  selector: 'fa-kt-vorlagen-sorter',
  templateUrl: './vorlagen-sorter.component.html',
  styleUrls: ['./vorlagen-sorter.component.css'],
})
export class VorlagenSorterComponent {
  public VorlagenSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public vorlagen: VorlagenService,
  ) {
    this.VorlagenSorterConfig = VorlagenQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
